var _title, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  focusable: "false"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "twitter-x")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  className: "s0",
  d: "m12 23.4q-2.3 0-4.4-0.9-2-0.9-3.6-2.5-1.5-1.5-2.4-3.6-0.8-2.1-0.8-4.4 0-2.3 0.8-4.4 0.9-2 2.4-3.6 1.6-1.5 3.6-2.4 2.1-0.9 4.4-0.9 2.2 0 4.3 0.9 2 0.9 3.6 2.4 1.5 1.6 2.4 3.6 0.9 2.1 0.9 4.4 0 2.3-0.9 4.4-0.9 2.1-2.4 3.6-1.6 1.6-3.6 2.5-2.1 0.9-4.3 0.9zm0-22c-5.9 0-10.6 4.7-10.6 10.6 0 5.9 4.7 10.7 10.6 10.7 5.8 0 10.5-4.8 10.5-10.7 0-5.9-4.7-10.6-10.5-10.6z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  className: "s0",
  d: "m9.3 5.7l3.4 4.6 4.2-4.6h1.2l-4.9 5.3 5.5 7.4h-4l-3.7-5-4.6 5h-1.2l5.3-5.7-5.2-7zm5.8 11.8h1.9l-8.2-11h-1.8z"
}))));
export default SvgTwitterX;